// extracted by mini-css-extract-plugin
export var accentcolor = "#00cc6d";
export var activeCommand = "vimsample-module--active-command--5b68f";
export var button = "vimsample-module--button--483b3";
export var commandArea = "vimsample-module--command-area--a9090";
export var cursor = "vimsample-module--cursor--b2adf";
export var right = "vimsample-module--right--4ebc8";
export var sample = "vimsample-module--sample--8ed39";